
import { createDevCamera } from '@webgl/dev/cameras';
import gui         from '@webgl/dev/gui'
import { Control } from '@webgl/dev/gui/api';

import { DEG2RAD } from "@webgl/math";
import Renderer from "@webgl/Renderer";
import { mat4 } from "gl-matrix";
import Camera from "nanogl-camera";
import PerspectiveLens from "nanogl-camera/perspective-lens";

import CameraManager from './CameraManager';


export type CameraName = 'main' | 'dev' | string


export default class Cameras {

  private _managers = new Map<CameraName,CameraManager<PerspectiveLens>>()

  private _current: CameraManager<PerspectiveLens>;
  
  constructor( readonly renderer:Renderer ){
    const mainManager   = new CameraManager(Cameras.makeDefaultCamera())
    this.registerCamera( mainManager, 'main' )
    
    
/////////////////
///////////////////////////////
///////////////////////////////////////////////////////////
////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////
/////
/////////////////////////////////////////////
//////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////
/////
///////////////////////////////////////////////////////////////
///////////////
/////////////////////
////
/////////////
    this.use( 'main' )
//////////////

  }

  /**
   * the active camera
   */
  get camera()     : Camera<PerspectiveLens>{
    return this._current.camera
  }

  get mainCamera():Camera<PerspectiveLens> {
    return this._managers.get( 'main' ).camera
  }

  get current(): CameraManager {
    return this._current
  }

  use( name:CameraName ):void {
    this._current?.stop()
    console.assert( this._managers.has(name), `camera manager ${name} doesn't exist` )
    this._current = this._managers.get( name )
    this._current?.start()
    
/////////////////
////////////////////////////
//////////////
  }

  
  registerCamera( manager : CameraManager<PerspectiveLens>, name:CameraName ):void {
    console.assert( !this._managers.has(name), `camera manager ${name} already registered` )
    this._managers.set( name, manager )
    // this.renderer.scene.root.add( manager.camera )
  }


  preRender():void{
    this.current.preRender()
    this.camera.updateWorldMatrix()
  }


  static makeDefaultCamera():Camera<PerspectiveLens> {
    // const camera = Camera.makePerspectiveCamera()
    const camera = new Camera( new PerspectiveLens() );
    camera.lens.setAutoFov(35.0 * DEG2RAD) //80
    camera.lens.near = .01
    camera.lens.far = 50

    camera.setMatrix(new Float32Array(
      [-0.006243415176868439, -4.046015931180591e-7, 0.999979555606842, 0, 0.9574259519577026, 0.2886151671409607, 0.005978201981633902, 0, -0.288609117269516, 0.9574443697929382, -0.0018012915970757604, 0, -5.7314453125, 16.64695167541504, -0.6891012191772461, 1]
    ) as mat4)

    return camera
  }






///////////////
/////////////////
/////////////////////////////////////
///////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////
//////
////////////
////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////////////////////////////////
////////
////////////////////
////////////////////////////////////////////////
///////
//////
///

////////////////////////////////////////////

//////////////////////////////
/////////////////////////////////////
///////////////////////////////////////////
//////////////////////////////
/////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////////
///
////////////

}